module.exports = __webpack_public_path__ + "img/9blue.c8fd9f71.png";